<div class="collection-image-component" *ngIf="collection?.logo" appPrerenderStop>
  <div [class.done]="imgUrl" [ngStyle]="imgUrl ? {'background-image': 'url(' + imgUrl + ')'} : false" class="cover gradient-loading"></div>
  <img (error)="error = true" (load)="imgUrl = imgPreloadUrl" [src]="imgPreloadUrl" loading="lazy" />
  <img (error)="imgUrl = 'assets/blank.jpeg'" (load)="imgUrl = imgIpfsPreloadUrl" *ngIf="error" [src]="imgIpfsPreloadUrl" loading="lazy" />
</div>
